import type { IntlShape } from "react-intl";
import type { ConnectorPropertiesSchema } from "shared-ui";
import { Image, type ConnectionItemProps } from "@wayflyer/flyui";
import { IconShop24Line } from "@wayflyer/flyui-icons/24/line";
import { FundingApplicationSchemas } from "api-types";

import { COMMON_MESSAGES } from "../../../components/common-messages";
import type { BusinessModelData } from "../../../types";
import { isGoogleAnalyticsRequired, isRevenueRequired } from "../../../utils/funding-journey";
import type { FormattedFundingApplicationScreen } from "../../../queries/funding-application/queries";

export const constructUnsupportedPlatformsAsConnectionItems = (
  intl: IntlShape,
  fundingApplication: FormattedFundingApplicationScreen,
  businessModel: BusinessModelData,
  googleAnalyticsConnector?: ConnectorPropertiesSchema
): ConnectionItemProps[] => {
  const unsupportedPlatforms = [
    ...fundingApplication.selectedUnsupportedEcommerce,
    ...fundingApplication.selectedUnsupportedMarketingAnalytics,
    ...fundingApplication.selectedUnsupportedPayments,
  ];

  const unsupportedPlatformItems: ConnectionItemProps[] = unsupportedPlatforms.map(
    (platform) =>
      ({
        testId: `unsupported-platform-${platform}`,
        label: platform,
        logo: <IconShop24Line />,
        badgeStatus: "positive",
        badgeText: intl.formatMessage(COMMON_MESSAGES.added),
      } satisfies ConnectionItemProps)
  );

  const gaItems: ConnectionItemProps[] =
    fundingApplication.selectedConnectorSlugs.includes("ga") &&
    isRevenueRequired(businessModel, fundingApplication) &&
    !isGoogleAnalyticsRequired(fundingApplication.selectedConnectorSlugs) &&
    googleAnalyticsConnector
      ? [
          {
            testId: `connection-ga`,
            label: googleAnalyticsConnector.name,
            logo: googleAnalyticsConnector.connectionLogoSrc ? (
              <Image src={googleAnalyticsConnector.connectionLogoSrc} />
            ) : undefined,
            badgeStatus: "positive",
            badgeText: intl.formatMessage(COMMON_MESSAGES.added),
          },
        ]
      : [];

  return [...gaItems, ...unsupportedPlatformItems];
};

export const unsupportedPlatformsAsConnectionItemsProps = (
  intl: IntlShape,
  fundingApplication: FormattedFundingApplicationScreen,
  fundingApplicationStages: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen,
  googleAnalyticsConnector?: ConnectorPropertiesSchema
): ConnectionItemProps[] => {
  const unsupportedPlatforms = [
    ...fundingApplication.selectedUnsupportedEcommerce,
    ...fundingApplication.selectedUnsupportedMarketingAnalytics,
    ...fundingApplication.selectedUnsupportedPayments,
  ];
  const unsupportedPlatformItems: ConnectionItemProps[] = unsupportedPlatforms.map(
    (platform) =>
      ({
        testId: `unsupported-platform-${platform}`,
        label: platform,
        logo: <IconShop24Line />,
        badgeStatus: "positive",
        badgeText: intl.formatMessage(COMMON_MESSAGES.added),
      } satisfies ConnectionItemProps)
  );

  const gaItems: ConnectionItemProps[] =
    fundingApplication.selectedConnectorSlugs.includes("ga") &&
    !isGoogleAnalyticsRequired(fundingApplication.selectedConnectorSlugs) &&
    googleAnalyticsConnector
      ? [
          {
            testId: `connection-ga`,
            label: googleAnalyticsConnector.name,
            logo: googleAnalyticsConnector.connectionLogoSrc ? (
              <Image src={googleAnalyticsConnector.connectionLogoSrc} />
            ) : undefined,
            badgeStatus: "positive",
            badgeText: intl.formatMessage(COMMON_MESSAGES.added),
          },
        ]
      : [];
  return [...gaItems, ...unsupportedPlatformItems];
};
